const emailFormStructure = [
  {
    key: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'Input email...',
    width: '1',
    required: true,
    help: 'make sure email is valid and active',
  },
  {
    key: 'repeat_email',
    label: 'Repeat Email',
    type: 'email',
    placeholder: 'Input Repeat Email...',
    width: '1',
    required: true,
    help: 'confirm you email is valid',
  },
];

const runnerFormStructure = [
  {
    key: 'name',
    label: 'Name',
    type: 'text',
    placeholder: 'Input Fullname...',
    width: '1/2',
    required: true,
    help: 'inline with identity',
  },
  {
    key: 'contact',
    label: 'Phone Number',
    type: 'number',
    placeholder: 'Input Contact...',
    width: '1/2',
    required: true,
    help: 'input your active phone number',
  },
  {
    key: 'gender',
    label: 'Gender',
    type: 'select',
    placeholder: 'Select Gender...',
    required: true,
    width: '1/2',
    options: [
      { value: 'm', label: 'Laki-Laki' },
      { value: 'f', label: 'Perempuan' },
    ],
  },
  {
    key: 'nationality',
    label: 'Nationality',
    type: 'select',
    placeholder: 'Select Nationality...',
    width: '1/2',
    required: true,
    options: [
      { label: 'Indonesia', value: 'ID' },
      { label: 'Afghanistan', value: 'AF' },
      { label: 'Aland Islands', value: 'AX' },
      { label: 'Albania', value: 'AL' },
      { label: 'Algeria', value: 'DZ' },
      { label: 'American Samoa', value: 'AS' },
      { label: 'Andorra', value: 'AD' },
      { label: 'Angola', value: 'AO' },
      { label: 'Anguilla', value: 'AI' },
      { label: 'Antarctica', value: 'AQ' },
      { label: 'Antigua and Barbuda', value: 'AG' },
      { label: 'Argentina', value: 'AR' },
      { label: 'Armenia', value: 'AM' },
      { label: 'Aruba', value: 'AW' },
      { label: 'Australia', value: 'AU' },
      { label: 'Austria', value: 'AT' },
      { label: 'Azerbaijan', value: 'AZ' },
      { label: 'Bahamas', value: 'BS' },
      { label: 'Bahrain', value: 'BH' },
      { label: 'Bangladesh', value: 'BD' },
      { label: 'Barbados', value: 'BB' },
      { label: 'Belarus', value: 'BY' },
      { label: 'Belgium', value: 'BE' },
      { label: 'Belize', value: 'BZ' },
      { label: 'Benin', value: 'BJ' },
      { label: 'Bermuda', value: 'BM' },
      { label: 'Bhutan', value: 'BT' },
      { label: 'Bolivia', value: 'BO' },
      { label: 'Bosnia and Herzegovina', value: 'BA' },
      { label: 'Botswana', value: 'BW' },
      { label: 'Bouvet Island', value: 'BV' },
      { label: 'Brazil', value: 'BR' },
      { label: 'British Indian Ocean Territory', value: 'IO' },
      { label: 'Brunei Darussalam', value: 'BN' },
      { label: 'Bulgaria', value: 'BG' },
      { label: 'Burkina Faso', value: 'BF' },
      { label: 'Burundi', value: 'BI' },
      { label: 'Cambodia', value: 'KH' },
      { label: 'Cameroon', value: 'CM' },
      { label: 'Canada', value: 'CA' },
      { label: 'Cape Verde', value: 'CV' },
      { label: 'Cayman Islands', value: 'KY' },
      { label: 'Central African Republic', value: 'CF' },
      { label: 'Chad', value: 'TD' },
      { label: 'Chile', value: 'CL' },
      { label: 'China', value: 'CN' },
      { label: 'Christmas Island', value: 'CX' },
      { label: 'Cocos (Keeling) Islands', value: 'CC' },
      { label: 'Colombia', value: 'CO' },
      { label: 'Comoros', value: 'KM' },
      { label: 'Congo', value: 'CG' },
      { label: 'Cook Islands', value: 'CK' },
      { label: 'Costa Rica', value: 'CR' },
      { label: 'Croatia', value: 'HR' },
      { label: 'Cuba', value: 'CU' },
      { label: 'Cyprus', value: 'CY' },
      { label: 'Czech Republic', value: 'CZ' },
      { label: 'Denmark', value: 'DK' },
      { label: 'Djibouti', value: 'DJ' },
      { label: 'Dominica', value: 'DM' },
      { label: 'Dominican Republic', value: 'DO' },
      { label: 'Ecuador', value: 'EC' },
      { label: 'Egypt', value: 'EG' },
      { label: 'El Salvador', value: 'SV' },
      { label: 'Equatorial Guinea', value: 'GQ' },
      { label: 'Eritrea', value: 'ER' },
      { label: 'Estonia', value: 'EE' },
      { label: 'Ethiopia', value: 'ET' },
      { label: 'Falkland Islands (Malvinas)', value: 'FK' },
      { label: 'Faroe Islands', value: 'FO' },
      { label: 'Fiji', value: 'FJ' },
      { label: 'Finland', value: 'FI' },
      { label: 'France', value: 'FR' },
      { label: 'French Guiana', value: 'GF' },
      { label: 'French Polynesia', value: 'PF' },
      { label: 'French Southern Territories', value: 'TF' },
      { label: 'Gabon', value: 'GA' },
      { label: 'Gambia', value: 'GM' },
      { label: 'Georgia', value: 'GE' },
      { label: 'Germany', value: 'DE' },
      { label: 'Ghana', value: 'GH' },
      { label: 'Gibraltar', value: 'GI' },
      { label: 'Greece', value: 'GR' },
      { label: 'Greenland', value: 'GL' },
      { label: 'Grenada', value: 'GD' },
      { label: 'Guadeloupe', value: 'GP' },
      { label: 'Guam', value: 'GU' },
      { label: 'Guatemala', value: 'GT' },
      { label: 'Guernsey', value: 'GG' },
      { label: 'Guinea', value: 'GN' },
      { label: 'Guinea-Bissau', value: 'GW' },
      { label: 'Guyana', value: 'GY' },
      { label: 'Haiti', value: 'HT' },
      { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
      { label: 'Holy See (Vatican City State)', value: 'VA' },
      { label: 'Honduras', value: 'HN' },
      { label: 'Hong Kong', value: 'HK' },
      { label: 'Hungary', value: 'HU' },
      { label: 'Iceland', value: 'IS' },
      { label: 'India', value: 'IN' },
      { label: 'Iran', value: 'IR' },
      { label: 'Iraq', value: 'IQ' },
      { label: 'Ireland', value: 'IE' },
      { label: 'Isle of Man', value: 'IM' },
      { label: 'Israel', value: 'IL' },
      { label: 'Italy', value: 'IT' },
      { label: 'Jamaica', value: 'JM' },
      { label: 'Japan', value: 'JP' },
      { label: 'Jersey', value: 'JE' },
      { label: 'Jordan', value: 'JO' },
      { label: 'Kazakhstan', value: 'KZ' },
      { label: 'Kenya', value: 'KE' },
      { label: 'Kiribati', value: 'KI' },
      { label: 'Korea', value: 'KR' },
      { label: 'Kuwait', value: 'KW' },
      { label: 'Kyrgyzstan', value: 'KG' },
      { label: 'Latvia', value: 'LV' },
      { label: 'Lebanon', value: 'LB' },
      { label: 'Lesotho', value: 'LS' },
      { label: 'Liberia', value: 'LR' },
      { label: 'Libyan Arab Jamahiriya', value: 'LY' },
      { label: 'Liechtenstein', value: 'LI' },
      { label: 'Lithuania', value: 'LT' },
      { label: 'Luxembourg', value: 'LU' },
      { label: 'Macao', value: 'MO' },
      { label: 'North Macedonia', value: 'MK' },
      { label: 'Madagascar', value: 'MG' },
      { label: 'Malawi', value: 'MW' },
      { label: 'Malaysia', value: 'MY' },
      { label: 'Maldives', value: 'MV' },
      { label: 'Mali', value: 'ML' },
      { label: 'Malta', value: 'MT' },
      { label: 'Marshall Islands', value: 'MH' },
      { label: 'Martinique', value: 'MQ' },
      { label: 'Mauritania', value: 'MR' },
      { label: 'Mauritius', value: 'MU' },
      { label: 'Mayotte', value: 'YT' },
      { label: 'Mexico', value: 'MX' },
      { label: 'Micronesia', value: 'FM' },
      { label: 'Moldova', value: 'MD' },
      { label: 'Monaco', value: 'MC' },
      { label: 'Mongolia', value: 'MN' },
      { label: 'Montserrat', value: 'MS' },
      { label: 'Morocco', value: 'MA' },
      { label: 'Mozambique', value: 'MZ' },
      { label: 'Myanmar', value: 'MM' },
      { label: 'Namibia', value: 'NA' },
      { label: 'Nauru', value: 'NR' },
      { label: 'Nepal', value: 'NP' },
      { label: 'Netherlands', value: 'NL' },
      { label: 'Netherlands Antilles', value: 'AN' },
      { label: 'New Caledonia', value: 'NC' },
      { label: 'New Zealand', value: 'NZ' },
      { label: 'Nicaragua', value: 'NI' },
      { label: 'Niger', value: 'NE' },
      { label: 'Nigeria', value: 'NG' },
      { label: 'Niue', value: 'NU' },
      { label: 'Norfolk Island', value: 'NF' },
      { label: 'Northern Mariana Islands', value: 'MP' },
      { label: 'Norway', value: 'NO' },
      { label: 'Oman', value: 'OM' },
      { label: 'Pakistan', value: 'PK' },
      { label: 'Palau', value: 'PW' },
      { label: 'Palestinian Territory', value: 'PS' },
      { label: 'Panama', value: 'PA' },
      { label: 'Papua New Guinea', value: 'PG' },
      { label: 'Paraguay', value: 'PY' },
      { label: 'Peru', value: 'PE' },
      { label: 'Philippines', value: 'PH' },
      { label: 'Pitcairn Islands', value: 'PN' },
      { label: 'Poland', value: 'PL' },
      { label: 'Portugal', value: 'PT' },
      { label: 'Puerto Rico', value: 'PR' },
      { label: 'Qatar', value: 'QA' },
      { label: 'Reunion', value: 'RE' },
      { label: 'Romania', value: 'RO' },
      { label: 'Russian Federation', value: 'RU' },
      { label: 'Rwanda', value: 'RW' },
      { label: 'Saint Helena', value: 'SH' },
      { label: 'Saint Kitts and Nevis', value: 'KN' },
      { label: 'Saint Lucia', value: 'LC' },
      { label: 'Saint Pierre and Miquelon', value: 'PM' },
      { label: 'Saint Vincent and the Grenadines', value: 'VC' },
      { label: 'Samoa', value: 'WS' },
      { label: 'San Marino', value: 'SM' },
      { label: 'Sao Tome and Principe', value: 'ST' },
      { label: 'Saudi Arabia', value: 'SA' },
      { label: 'Senegal', value: 'SN' },
      { label: 'Serbia and Montenegro', value: 'CS' },
      { label: 'Seychelles', value: 'SC' },
      { label: 'Sierra Leone', value: 'SL' },
      { label: 'Singapore', value: 'SG' },
      { label: 'Slovakia', value: 'SK' },
      { label: 'Slovenia', value: 'SI' },
      { label: 'Solomon Islands', value: 'SB' },
      { label: 'Somalia', value: 'SO' },
      { label: 'South Africa', value: 'ZA' },
      {
        label: 'South Georgia and the South Sandwich Islands',
        value: 'GS',
      },
      { label: 'Spain', value: 'ES' },
      { label: 'Sri Lanka', value: 'LK' },
      { label: 'Sudan', value: 'SD' },
      { label: 'Suriname', value: 'SR' },
      { label: 'Svalbard and Jan Mayen', value: 'SJ' },
      { label: 'Swaziland', value: 'SZ' },
      { label: 'Sweden', value: 'SE' },
      { label: 'Switzerland', value: 'CH' },
      { label: 'Syrian Arab Republic', value: 'SY' },
      { label: 'Taiwan', value: 'TW' },
      { label: 'Tajikistan', value: 'TJ' },
      { label: 'Tanzania', value: 'TZ' },
      { label: 'Thailand', value: 'TH' },
      { label: 'Timor-Leste', value: 'TL' },
      { label: 'Togo', value: 'TG' },
      { label: 'Tokelau', value: 'TK' },
      { label: 'Tonga', value: 'TO' },
      { label: 'Trinidad and Tobago', value: 'TT' },
      { label: 'Tunisia', value: 'TN' },
      { label: 'Turkey', value: 'TR' },
      { label: 'Turkmenistan', value: 'TM' },
      { label: 'Turks and Caicos Islands', value: 'TC' },
      { label: 'Tuvalu', value: 'TV' },
      { label: 'Uganda', value: 'UG' },
      { label: 'Ukraine', value: 'UA' },
      { label: 'United Arab Emirates', value: 'AE' },
      { label: 'United Kingdom', value: 'GB' },
      { label: 'United States', value: 'US' },
      { label: 'United States Minor Outlying Islands', value: 'UM' },
      { label: 'Uruguay', value: 'UY' },
      { label: 'Uzbekistan', value: 'UZ' },
      { label: 'Vanuatu', value: 'VU' },
      { label: 'Venezuela', value: 'VE' },
      { label: 'Vietnam', value: 'VN' },
      { label: 'Virgin Islands, British', value: 'VG' },
      { label: 'Virgin Islands, U.S.', value: 'VI' },
      { label: 'Wallis and Futuna', value: 'WF' },
      { label: 'Western Sahara', value: 'EH' },
      { label: 'Yemen', value: 'YE' },
      { label: 'Zambia', value: 'ZM' },
      { label: 'Zimbabwe', value: 'ZN' },
    ],
  },
  {
    key: 'id_type',
    label: 'ID Type',
    type: 'select',
    placeholder: 'Select ID Type...',
    width: '1/2',
    required: true,
    options: [
      { value: 'ktp', label: 'KTP' },
      { value: 'paspor', label: 'Paspor' },
      { value: 'kitas', label: 'KITAS' },
      { value: 'kartu-pelajar', label: 'Kartu Pelajar' },
      { value: 'sim', label: 'SIM' },
    ],
  },
  {
    key: 'id_number',
    label: 'ID Number',
    type: 'text',
    placeholder: 'Input ID Number...',
    width: '1/2',
    required: true,
    help: 'inline with identity',
  },
  {
    key: 'brith_date',
    label: 'Birth Date',
    type: 'datepicker',
    placeholder: 'Select Birth Date...',
    width: '1/2',
    required: true,
    min: '1900-01-01',
    max: '2099-12-31',
  },
  {
    key: 'blood_type',
    label: 'Blood Type',
    type: 'select',
    placeholder: 'Select Blood Type...',
    width: '1/2',
    required: true,
    options: [
      { value: 'a+', label: 'A+' },
      { value: 'a-', label: 'A-' },
      { value: 'b+', label: 'B+' },
      { value: 'b-', label: 'B-' },
      { value: 'ab+', label: 'AB+' },
      { value: 'ab-', label: 'AB-' },
      { value: 'o+', label: 'O+' },
      { value: 'o-', label: 'O-' },
      { value: 'none', label: 'Tidak Tahu!' },
    ],
  },
  {
    key: 'org_kom',
    label: 'Are you part of running club?',
    type: 'radio-group',
    width: '1',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Yes',
        width: '1/2',
        view: {
          key: 'org_com',
          label: '',
          type: 'text',
          placeholder: 'Input Running Club...',
          width: '1',
          required: true,
        },
      },
      { value: 'no', label: 'No', width: '1/2' },
    ],
  },
  {
    key: 'rpt_10',
    label: 'Race Prediction Time (10Km)',
    type: 'select',
    placeholder: 'Select...',
    width: '1',
    required: true,
    visibleWhen: { field: 'race_category', equals: '10k' },
    help: 'You will be assigned to the Start Pen which reflects your predicted race time. Selecting the right Pen will ensure a better race for yourself and runners around you.',
    options: [
      { value: 'pen_a', label: 'Pen A: Below 45 Minutes' },
      { value: 'pen_b', label: 'Pen B: 45 Mnitues - 1:00hr' },
      { value: 'pen_c', label: 'Pen C: 1:01hrs - 1:15hrs' },
      { value: 'pen_d', label: 'Pen D: 1:16hrs - 1:30hrs' },
      { value: 'pen_e', label: 'Pen E: 1:31hrs - 2:00hrs' },
    ],
  },
  {
    key: 'rpt_21',
    label: 'Race Pediction Time (21Km)',
    type: 'select',
    placeholder: 'Select...',
    width: '1',
    required: true,
    help: 'You will be assigned to the Start Pen which reflects your predicted race time. Selecting the right Pen will ensure a better race for yourself and runners around you. NOTE: Submission of timing proof if you select Competitive : below 1:20 hrs. Failing to submit your timing proof will result in shifting you to the next available Start Pen',
    visibleWhen: { field: 'race_category', equals: '21k' },
    options: [
      {
        value: 'competitive',
        label: 'Competitive: Below 1:20hrs',
      },
      { value: 'pen_a', label: 'Pen A: Below 1:40hrs' },
      { value: 'pen_b', label: 'Pen B: Below 1:45hrs' },
      { value: 'pen_c', label: 'Pen C: 1:46hrs - 2:00hrs' },
      { value: 'pen_d', label: 'Pen D: 2:01hrs - 2:15hrs' },
      { value: 'pen_e', label: 'Pen E: 2:16hrs - 2:30hrs' },
      { value: 'pen_f', label: 'Pen F: 2:31hrs - 3:00hrs' },
      { value: 'pen_g', label: 'Pen G: More than 3:00hrs' },
    ],
  },
  {
    key: 'exp_fin_time',
    label: 'WHAT IS YOUR EXPECTED FINISH TIME?',
    type: 'counter-group',
    width: '1',
    required: true,
    children: [
      {
        key: 'hour',
        placeholder: 'hh',
        required: true,
        type: 'number-counter',
        min: 0,
        max: 12,
      },
      {
        key: 'minute',
        placeholder: 'mm',
        required: true,
        type: 'number-counter',
        min: 0,
        max: 60,
      },
      {
        key: 'second',
        placeholder: 'ss',
        required: true,
        type: 'number-counter',
        min: 0,
        max: 60,
      },
    ],
  },
  {
    key: 'medical_note',
    label: 'Medical Information',
    type: 'text-area',
    placeholder: 'Input Medical Information...',
    width: '1',
    help: 'PLEASE LET US KNOW OF ANY MEDICAL CONDITIONS WE NEED TO BE AWARE OF DURING YOUR PARTICIPATION',
  },
  {
    key: 'size',
    label: 'Jersey Size',
    type: 'select',
    placeholder: 'Pilih size...',
    width: '1/2',
    required: true,
    options: [], // akan dioverride dari useSizes
  },
];

const emergencyFormStructure = [
  {
    key: 'emergency_person',
    label: 'Name',
    type: 'text',
    placeholder: 'Input Name...',
    width: '1',
    required: true,
  },
  {
    key: 'emergency_contact',
    label: 'Contact',
    type: 'number',
    placeholder: 'Input Contact...',
    width: '1',
    required: true,
  },
  {
    key: 'emergency_relation',
    label: 'Relation',
    type: 'select',
    placeholder: 'Select Relation...',
    width: '1',
    required: true,
    options: [
      { value: 'keluarga', label: 'Keluarga' },
      { value: 'ortu', label: 'Orang Tua' },
      { value: 'saudara', label: 'Saudara' },
      { value: 'sum_is', label: 'Suami/Istri' },
      { value: 'guru', label: 'Guru' },
      { value: 'teman', label: 'Teman' },
    ],
  },
];

//  view: {
//           label: `Foto Bukti Lari`,
//           name: 'foto_bukti',
//           type: 'file',
//           accept: 'image/*',
//           required: true,
//           placeholder: 'Pilih foto',
//         },
export { emailFormStructure, runnerFormStructure, emergencyFormStructure };
